"use strict";

module.exports = function () {
  var resolver = /* @ngInject */function resolver(eventService) {
    var event = eventService.getCurrentEvent();
    return eventService.getEventParticipantsInfo(event);
  };
  resolver.$inject = ["eventService"];
  return resolver;
};